import { getRequest, postRequest } from 'sync/request';
import type { OrganizationContext } from 'sync/request.types';
import {
  CreateFreeAppServiceContext,
  CreateFreeAppServiceResponse,
  CreateTrialAppServiceContext,
  CreateTrialAppServiceResponse,
  CreateTrialDatabasePayload,
  CreateTrialDatabaseResponse,
  TrialContext,
  TrialDatabaseResponse,
  TrialExecuteUpgradePayload,
  TrialInfo,
  TrialInfoContext,
  TrialInfoResponse,
  TrialResponse,
  TrialUpgradePayload,
} from 'sync/trial-service/trial-service.types';

/**
 * Retrieve details for a trial database.
 */
export function getTrial({ organizationId }: Pick<TrialContext, 'organizationId'>) {
  return getRequest<TrialResponse>(`/v2/organizations/${organizationId}/trial`);
}

/**
 * Retrieve the information for a trial
 */
export function getTrialInfo({ organizationId }: TrialInfoContext) {
  return getRequest<TrialInfoResponse>(`/v2/organizations/${organizationId}/trial/upgrade/info`);
}

/**
 * Get trial database details
 */

export const getTrialDatabase = (params: OrganizationContext) => {
  return getRequest<TrialDatabaseResponse>(`/v2/organizations/${params.organizationId}/trial/cluster`);
};

/**
 * Create trial database.
 */
export function createTrialDatabase({ organizationId }: TrialContext, payload: CreateTrialDatabasePayload) {
  return postRequest<CreateTrialDatabaseResponse>(`/v2/organizations/${organizationId}/trial/cluster`, { data: payload });
}

/**
 * Create trial app service.
 */
export function createTrialAppService({ organizationId }: TrialContext, payload: CreateTrialAppServiceContext) {
  return postRequest<CreateTrialAppServiceResponse>(`/v2/organizations/${organizationId}/trial/backends`, { data: payload });
}

export function createFreeAppService({ organizationId }: TrialContext, payload: CreateFreeAppServiceContext) {
  return postRequest<CreateFreeAppServiceResponse>(`/v2/organizations/${organizationId}/trial/backends`, { data: payload });
}

/**
 * Upgrade and activate account from trial.
 */
export function upgradeTrial({ organizationId }: OrganizationContext, payload: TrialUpgradePayload) {
  return postRequest<TrialInfo | undefined>(`/v2/organizations/${organizationId}/trial/upgrade/activation`, { data: payload });
}

/**
 * Extend trial.
 */

export function extendTrial({ organizationId }: OrganizationContext) {
  return postRequest<{}>(`/v2/organizations/${organizationId}/trial/extend`);
}

/**
 * Execute an upgrade on a trial account
 */
export function upgradeTrialExec({ organizationId }: OrganizationContext, { keepDatabases }: TrialExecuteUpgradePayload) {
  return postRequest<{}>(
    `/v2/organizations/${organizationId}/trial/upgrade/exec`,
    // This sends both value to the API on purpose. Currently on the API, if keepClusters === false
    // and deleteClusters === false, it will result in an error. This is done to ensure that we don't
    // end up with that scenario.
    { data: { keepClusters: keepDatabases, deleteClusters: !keepDatabases } }
  );
}

export function activateFreeTier({ organizationId }: OrganizationContext) {
  return postRequest<{}>(`/v2/organizations/${organizationId}/trial/activate-free-tier`);
}
